// extracted by mini-css-extract-plugin
export var dropdownMenu = "index-module--dropdown-menu--sqPe1";
export var show = "index-module--show--HbXP0";
export var lastContainer = "index-module--last-container--16sbH";
export var logoFooterContainer = "index-module--logo-footer-container--Yo3oy";
export var sectionTitle = "index-module--section-title--NGETD";
export var discosDiv = "index-module--discos-div--sBbB1";
export var musicPlatformIcon = "index-module--music-platform-icon--1tH84";
export var myFooter = "index-module--my-footer--C-RQu";
export var footerIcons = "index-module--footer-icons--zgRLp";
export var logo = "index-module--logo--60Vd8";
export var footerLogoText = "index-module--footer-logo-text--PnPYq";
export var spotifyDiskDiv = "index-module--spotify-disk-div--X8j67";
export var divFooterCol = "index-module--div-footer-col--zIPTv";
export var iconSvg = "index-module--icon-svg--FV+ZQ";